import React from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Container,
  Col,
} from 'react-bootstrap';

import AuthFooter from 'components/Footers/AuthFooter.js';
import NotFoundPage from 'views/NotFoundPage';

// dinamically create auth routes
import routes from 'routes.js';

function Auth() {
  const location = useLocation();
  const isAdminLoginPage = location.pathname === '/auth/login-page';

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === '/auth') {
        return (
          <Route
            exact
            path={prop.layout + prop.path}
            key={key}
            component={prop.component}
          />
        );
      } else {
        return null;
      }
    });
  };
  return (
    <>
      <div className='wrapper wrapper-full-page'>
        {/* Navbar */}
        {/* <AuthNavbar /> */}
        {/* End Navbar */}
        <Switch>
          {getRoutes(routes)}
          <Route render={() => <NotFoundPage variant="auth" />} />
        </Switch>
        {!isAdminLoginPage && <AuthFooter />}
      </div>
      {/* <FixedPlugin /> */}
    </>
  );
}

export default Auth;
